import loopback from '@/services/loopback'

export default {
  getMyOnboarding () {
    return loopback.get('/onboarding/me')
  },
  getCrms () {
    return loopback.get('/crms', { params: { filter: { order: 'name ASC' } } })
  },
  completeCrmStep ({ crm }) {
    return loopback.put('/onboarding/me/steps/step-1', { data: { crm } })
  },
  completeWebphoneStep ({ manualConfirmation = false, finalizes = true } = {}) {
    const payload = { data: { manualConfirmation } }
    if (finalizes) payload.completesOnboarding = true
    return loopback.put('/onboarding/me/steps/step-4', payload)
  },
  completeNetworkTestStep ({ latencyMs, jitterMs, packetLossPct, color }) {
    return loopback.put('/onboarding/me/steps/step-5', {
      data: {
        latency_ms: latencyMs,
        jitter_ms: jitterMs,
        packet_loss_pct: packetLossPct,
        color
      },
      completesOnboarding: true
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/onboarding.js